import { render, staticRenderFns } from "./historyVideo.vue?vue&type=template&id=08ed2259&scoped=true"
import script from "./historyVideo.vue?vue&type=script&lang=js"
export * from "./historyVideo.vue?vue&type=script&lang=js"
import style0 from "./historyVideo.vue?vue&type=style&index=0&id=08ed2259&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed2259",
  null
  
)

export default component.exports